<template>
  <div class="cookie-consent-container" v-if="shown">
    <div class="cookie-consent-content">
      <p>
        This website uses cookies to ensure you get the best experience on our website:
        <a href="https://www.playrix.com/cookies" target="_blank">More info</a>
      </p>
      <v-btn @click="handleAccept">Accept</v-btn>
    </div>
  </div>
</template>

<script>
import { getFromLocal, saveToLocal } from '@/helpers/storage';

export default {
  data() {
    return {
      consent: null,
    };
  },
  mounted() {
    this.consent = getFromLocal('cookie-consent') || false;
  },
  computed: {
    shown() {
      return this.consent !== null && !this.consent;
    },
  },
  methods: {
    handleAccept() {
      this.consent = true;
      saveToLocal('cookie-consent', this.consent);
    },
  },
};
</script>
<style lang="scss" scoped>
.cookie-consent-container {
  position: relative;
}
.cookie-consent-content {
  padding: 30px;
  background-color: #f8f8f8;
  border-radius: 4px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  position: fixed;
  left: 24px;
  bottom: 24px;
  max-width: 18rem;
  z-index: 10;
  transition: visibility 0s, opacity 0.2s linear;
  box-shadow: 1px 2px 10px #d0d0d0;
  font-size: 14px;
}
</style>
